import { Box } from '@mui/material'
import { ReactNode } from 'react'

export default function ContentComponentWrapper({ children }: { children: ReactNode }) {
  return <Box sx={{ pt: 2, pr: 2, pl: 2, width: '100%' }}>{children}</Box>
}
